module.exports = __webpack_public_path__ + "img/indonesia.ff73e75.webp";